import Component from 'component';
class SliderHero extends Component {
  constructor(el) {
    super(el);
    this.initSlick();
  }

  setupDefaults() {
    this.dom = {
      $slider: this.$el.find('.slider-hero__slider'),
      $dotsContainer: this.$el.find('.slider-hero__dots'),
      $prevArrow: this.$el.find('.slick-prev'),
      $nextArrow: this.$el.find('.slick-next')
    };
    this.autoplaySpeed = parseInt(this.$el.data('autoplaySpeed')) || 5000;
  }

  addListeners() {
  }

  initSlick() {
    const _that = this;
    if (this.$el.next().hasClass('form-offer')){
      this.$el.addClass('has-form');
    }

    _that.dom.$slider.slick({
      infinite: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: _that.autoplaySpeed,
      prevArrow: this.dom.$prevArrow,
      nextArrow: this.dom.$nextArrow,
      slidesToShow: 1
    });
  }
}

export default SliderHero;




// WEBPACK FOOTER //
// ./src/btu/js/components/SliderHero.js